export const transformDiscountToValue = (discount)=>({
        value: discount?.type.toString(),
        label: discount?.name
    });

//# sourceMappingURL=select.js.map